import React from "react";
import { withStyles } from '@material-ui/core/styles';
import '@fontsource/roboto';
import Button from '@material-ui/core/Button';


const useStyles = theme => ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  }
});


class PreReadingSurvey extends React.Component {

    constructor(props){
        super(props);
        this.state={
          load: 0
        }

        this.handleStart=this.handleStart.bind(this);
    }

    handleStart(event){
        event.preventDefault();
        window.location='../instruction/';
        
    }

    componentDidMount(){
      const self=this;
      setTimeout(() => {
        document.getElementById('pre-reading-survey').onload=function(){
          self.setState(()=>{
            return {
              load: self.state.load+1,
            };
        });
        }
      }, 1000);
    }

    render(){
      const { classes } = this.props;

      return (
          <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px', textAlign:'center'}}>
            <div>
             <iframe id='pre-reading-survey' title='pre-reading survey' src="https://docs.google.com/forms/d/e/1FAIpQLSdmO3Zu3eSz6cpDrL4d7MuachxeSCEfJ_gLv6rJsvZ7ew6xgw/viewform?embedded=true" style={{width:"1000px", height:"673px", frameBorder:"0", marginHeight:"0", marginWidth:"0"}} >Loading…</iframe>
            </div>
            <div style={{float:'right', marginRight: '30px', marginTop: '30px'}}>
              <form onSubmit={this.handleStart} >
              <Button variant='contained' color='primary'  className={classes.root} type="submit" disabled={this.state.load<7}>
                Next
              </Button>
              </form>
            </div>
          </div>
        );
  }
}

export default withStyles(useStyles)(PreReadingSurvey);

